// Matching has to be ranked, not just filtered. A list whose labels start
// with a date turns every query into a match on that date ("sep" contains
// "ep"), and an unranked result buries the row the reader meant behind
// dozens of incidental hits.
//
// Lower is better. null means no match at all.
export function rankMatch(primary: string, secondary: string, needle: string): number | null {
  const query = needle.trim().toLowerCase();
  if (query === "") return 0;
  const head = primary.toLowerCase();
  const tail = secondary.toLowerCase();
  if (head.startsWith(query)) return 0;
  if (startsAWord(head, query)) return 1;
  if (tail.startsWith(query) || startsAWord(tail, query)) return 2;
  if (head.includes(query)) return 3;
  if (tail.includes(query)) return 4;
  return null;
}

// True when the needle begins a word. \b is ASCII-only, so the boundary is
// checked against Unicode letters and digits instead: this list holds
// Georgian, Russian and Latin payees side by side.
function startsAWord(text: string, needle: string): boolean {
  const isWordChar = /[\p{L}\p{N}]/u;
  for (let at = text.indexOf(needle); at >= 0; at = text.indexOf(needle, at + 1)) {
    if (at === 0 || !isWordChar.test(text[at - 1])) return true;
  }
  return false;
}

// Filters and orders in one pass, keeping the original order inside a rank so
// a list that was sorted by date stays sorted by date among equal matches.
export function rankedFilter<T>(items: T[], needle: string, fields: (item: T) => [string, string]): T[] {
  if (needle.trim() === "") return items;
  return items
    .map((item, index) => {
      const [primary, secondary] = fields(item);
      return { item, index, rank: rankMatch(primary, secondary, needle) };
    })
    .filter((entry): entry is { item: T; index: number; rank: number } => entry.rank !== null)
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map((entry) => entry.item);
}
